import PageHeading from '../components/common/PageHeading';

const communityItems = [
  {
    category: '이야기',
    title: '승마 경험 나누기',
    body: '첫 기승 후기부터 꾸준한 강습 기록까지 승마를 즐기는 사람들의 이야기를 모아봅니다.',
  },
  {
    category: '질문',
    title: '궁금한 점 묻기',
    body: '복장, 준비물, 강습 선택처럼 승마를 시작할 때 필요한 질문을 자연스럽게 나눕니다.',
  },
  {
    category: '모임',
    title: '함께 타는 즐거움',
    body: '지역과 관심사에 맞는 승마 소식, 이벤트, 커뮤니티 활동을 확인합니다.',
  },
];

function CommunityPage() {
  return (
    <section className="page-section community-page" aria-labelledby="community-title">
      <PageHeading
        id="community-title"
        label="커뮤니티"
        title="승마 이야기를 함께 나누세요"
        description="승마를 시작하는 사람과 즐기는 사람이 경험, 질문, 소식을 편하게 나누는 공간입니다."
      />
      <div className="news-grid">
        {communityItems.map((item) => (
          <article className="news-card" key={item.title}>
            <span>{item.category}</span>
            <h2>{item.title}</h2>
            <p>{item.body}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default CommunityPage;
